<template>
  <div class="container">
    <!-- 选择工具 -->
    <div class="tools">
      <div
        class="tool-item"
        :class="{ active: lineState }"
        v-for="item in toos"
        :key="item.label"
        :title="item.label"
        @click="changeTool(item)"
      >
        <i :class="item.icon" class="iconfont" v-if="!item.image"></i>
        <img :src="item.image" class="iconfont image" v-else alt="" srcset="" />
        <div>{{ item.label }}</div>
      </div>
    </div>

    <!-- 选择组件 -->

    <div class="compoents-section">
      <el-collapse v-model="current">
        <el-collapse-item title="我的组件" name="myComponents">
          <div class="sprite-grid-container">
            <div
              class="gird-item"
              v-for="item2 in topoComponents"
              @dragstart="drag($event, { data: item2.data })"
              draggable="true"
              :title="item2.name"
              :key="item2.id"
            >
              <div class="sprite-content">
                <div
                  class="sprite-img zt"
                  :class="item2.icon"
                  :style="{
                    background: `url(${item2.image})no-repeat center`,
                    'background-size': 'contain',
                  }"
                ></div>
                <el-popover placement="bottom" width="150" trigger="click">
                  <div class="setting-menu-content">
                    <el-button
                      type="text"
                      class="btn-text"
                      @click="setComponent(componentEventType.delete, item2)"
                      >删除</el-button
                    >
                    <el-button
                      type="text"
                      class="btn-text"
                      @click="setComponent(componentEventType.rename, item2)"
                      >重命名</el-button
                    >
                    <!-- <el-button type="text" class="btn-text" @click="setComponent(componentEventType.upload,item2)">上传云端</el-button>
                    <el-button type="text" class="btn-text" @click="setComponent(componentEventType.setCommon,item2)">设置为共用组件</el-button> -->
                  </div>
                  <i
                    slot="reference"
                    class="el-icon-s-tools setting-my-component"
                  ></i>
                </el-popover>

                <!-- <div class="sprite-name">{{ item2.name }}</div> -->
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          :title="item.name"
          :name="index"
          v-for="(item, index) in spritesConfig"
          :key="item.name + item.id"
        >
          <div class="sprite-grid-container">
            <div
              class="gird-item"
              v-for="item2 in item.list"
              @dragstart="drag($event, item2)"
              draggable="true"
              :key="item2.id"
              :title="item2.name"
            >
              <div class="sprite-content">
                <div
                  class="sprite-img zt"
                  :class="item2.icon"
                  :style="{
                    background: `url(${item2.image})no-repeat center`,
                    'background-size': 'contain',
                  }"
                ></div>
                <!-- <div class="sprite-name">{{ item2.name }}</div> -->
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
import { propsTypes, ToolsTypes } from "./types/sprite-types";
import SpriteComponents from "./components";
import Core from "@/libs/src/core.js";
const componentEventType = {
  delete: 0,
  rename: 1,
  upload: 2,
  setCommon: 3,
};
export default {
  data() {
    return {
      current: 0,
      propsTypes: propsTypes,
      componentEventType: componentEventType, //我的组件事件类型
      topoComponents: [],
      toos: [
        {
          icon: "icon-shiwu-huabi",
          image: require("@/assets/mingcute_pen-fill.png"),
          label: "管道",
          key: ToolsTypes.Line,
        },
      ],
      lineActive: "curve",
      lineWidth: 1,
      spritesConfig: SpriteComponents,
      lineState: false, //钢笔绘画状态
    };
  },

  mounted() {
    // 获取自定义组件
    if (this.topo.TopoComponents.componentsReady) {
      this.topoComponents = this.topo.TopoComponents.components;
    } else {
      this.topo.TopoComponents.on("components.ready", (components) => {
        this.topoComponents = components;
      });
    }

    if (!this.topo.stageCanvas) {
      this.topo.on("stage-created", () => {
        this.stageEvent();
      });
    } else {
      this.stageEvent();
    }
  },
  created() {
    this.topo = Core.getProvider("TechnologyTopo");
    this.getComponents();
    this.topo.proc.watch("_components", (val) => {
      this.topoComponents = val;
    });
  },
  methods: {
    getComponents() {
      this.topo.components.getCate().then((res) => {
        
        res.forEach((item) => {
          let cate = {
            name: item.name,
            id: item.id + Date.now(),
            list: [],
          };
          item.craftElements.forEach((component, index) => {
            let data = JSON.parse(component.data);
            let obj = {
              id: component.id + "-" + index,
              name: component.name,
              image: component.image,
              data: {
                image: component.image,
                ...data,
              },
            };
            cate.list.push(obj);
          });
          this.spritesConfig.push(cate);
        });
      });
    },
    setting() {
      this.topo.emit("setting", this.topo.store);
    },
    // 保存为组件
    addToComponent() {
      this.topo.toComponent();
    },
    // 舞台的各种事件
    stageEvent() {
      //   鼠标 右键菜单
      this.topo.stageCanvas.on("contextmenu", ({ clientRect, e }) => {
        // 当前选中的活动对象
        let { active } = this.topo.store;

        let x = e.x,
          y = e.y;

        let menuItem = [
          {
            label: "复制 (Ctrl+C)",
            onClick: this.topo.copy,
          },
          { label: "粘贴 (Ctrl+V)", onClick: this.topo.paste },
          { label: "删除 (Delete)", divided: true, onClick: this.topo.delete },
          { label: "锁定/解锁", onClick: this.topo.lock },
          { label: "撤销 (Ctrl+Z)", onClick: this.topo.undo },
          { label: "恢复 (Shift+Z)", divided: true, onClick: this.topo.redo },
          { label: "组合", onClick: this.topo.combine },
          { label: "组合为状态", onClick: this.topo.combineState },
          { label: "取消组合", divided: true, onClick: this.topo.uncombine },
          {
            label: "保存为组件",
            divided: true,
            onClick: this.addToComponent,
          },
          {
            label: "复制样式",
            onClick: this.topo.copyStyle,
          },
          {
            label: "粘贴样式",
            divided: true,
            onClick: this.topo.pasteStyle,
          },
          {
            label: "置顶",
            onClick: this.topo.top,
          },
          {
            label: "置底",
            onClick: this.topo.bottom,
          },
          {
            label: "上移图层",
            onClick: this.topo.up,
          },
          {
            label: "下移图层",
            minWidth: 0,
            divided: true,
            onClick: this.topo.down,
          },
          { label: "设置", onClick: this.setting },
        ];

        // 没有选中状态下的右键菜单
        if (!active.length) {
          menuItem = [
            {
              label: "复制 (Ctrl+C)",
              disabled: true,
            },
            { label: "粘贴 (Ctrl+V)", onClick: this.topo.paste },
            { label: "删除 (Delete)", divided: true, disabled: true },
            { label: "锁定/解锁", onClick: this.topo.lock },
            { label: "撤销 (Ctrl+Z)", onClick: this.topo.undo },
            { label: "恢复 (Shift+Z)", divided: true, onClick: this.topo.redo },
            {
              label: "保存为组件",
              divided: true,
              onClick: this.addToComponent,
            },
            {
              label: "上移图层",
              disabled: true,
            },
            {
              label: "下移图层",
              minWidth: 0,
              disabled: true,
              divided: true,
            },
            { label: "设置", onClick: this.setting },
          ];
        }
        //   显示右键
        this.$contextmenu({
          items: menuItem,
          event: e,
          x: x,
          y: y,
          customClass: "custom-class",
          zIndex: 99999,
          minWidth: 230,
        });
      });
      this.topo.on("add.components", () => {
        this.$alert("已添加为组件");
      });
      // this.topo.stageCanvas.beforeAddPens = async (pens) => {

      //   return true;
      // };

      window.addEventListener("keydown", (e) => {
        if (e.code == "Enter" || e.code == "Escape") {
          this.lineState = false;
        }
      });
    },
    // 拖动到舞台
    drag(evt, item) {
      console.log(item);
      evt.dataTransfer.setData("Topology", JSON.stringify(item.data || "{}"));
    },
    changeTool(item) {
      switch (item.key) {
        case ToolsTypes.Line:
          // 使用画笔工具
          let lineName = this.topo.data.lineName || "line";
          this.topo.stageCanvas.drawLine(lineName);
          this.lineState = true;
          break;
      }
    },
    // 我的组件事件
    setComponent(eventType, item) {
      switch (eventType) {
        case this.componentEventType.delete:
          this.topo.removeComponent(item.id);
          break;
        case this.componentEventType.rename:
          let msg = window.prompt("请输入组件名称", item.name);
          if (!msg) return;
          item.name = msg;
          this.topo.updateComponent(item);
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  height: 100%;
  display: flex;
  width: 100%;
  .tools {
    width: 50px;
    background: #fdfdfd;
    border-right: 1px solid rgba($color: #000000, $alpha: 0.3);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0;
      opacity: 0;
      display: none;
    }
    .tool-item {
      text-align: center;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.3);
      height: 70px;
      cursor: pointer;
      .image {
        width: 35px;
      }
      .line-width-text {
        font-size: 25px;
      }
      & > i {
        font-size: 30px;
      }
    }
  }
  .compoents-section {
    width: calc(100% - 50px);
    overflow-y: auto;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      width: 0;
      opacity: 0.5;
    }
  }
}
.sprite-grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
  .gird-item {
    // height: 100px;
    // background: #000;
    border: 1px solid #fff;
    box-sizing: border-box;
    padding: 5px;
    .sprite-content {
      position: relative;
      cursor: pointer;
      .sprite-img {
        width: 100%;
        // height: 100px;
        min-height: 50px;
        text-align: center;
        font-size: 20px;
      }
      .sprite-name {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 5px 0;
        text-align: center;
      }

      .setting-my-component {
        position: absolute;
        top: 0;
        right: 0;
        &:hover {
          color: #cc6666;
        }
      }
    }
  }
}
.input-text {
  padding: 0;
  width: 100%;
  border: none;
  height: 50px;
  text-align: center;
  font-size: 18px;
}
.active {
  background-color: #008585;
}
.setting-menu-content {
  display: flex;
  flex-direction: column;
  .btn-text {
    text-align: left;
    margin: 0;
  }
}
</style>